import React, { createContext } from 'react';

import { useIndex } from '../hooks';

export const BequestsContext = createContext({ bequests: [], loading: false, update: () => {} });

export function BequestsProvider({ assetId, children }) {
  console.log('BeneficiariesProvider', assetId);
  const { data, loading, update } = useIndex('bequests', { asset_id: assetId });

  return (
    <BequestsContext.Provider value={{ bequests: data || [], loading, update }}>
      {children}
    </BequestsContext.Provider>
  );
}
